// Reusable legal-page renderer — 2026 rebrand: page-head + .legal styles.
import { useEffect } from "react";
import DOMPurify from "dompurify";
import MarketingShell from "../components/MarketingShell";

export default function LegalPage({ title, accent, effective, sections, testId }) {
  useEffect(() => {
    document.title = `${`${title}${accent ? ` ${accent}` : ""}`.replace(/\.+$/, "")} | JC3 Wealth Legacy Group`;
  }, [title, accent]);
  return (
    <MarketingShell>
      <div data-testid={testId}>
        <section className="page-head" aria-label={title}>
          <div className="wrap">
            <p className="small dim-dark">JC3 Wealth Legacy Group LLC</p>
            <h1 className="display-xl">{title}{accent ? ` ${accent}` : ""}</h1>
            <p className="small dim-dark">Effective Date: {effective}</p>
          </div>
        </section>
        <section className="band on-stone">
          <div className="wrap">
            <div className="legal">
              {sections.map((s) => (
                <div key={s.heading} data-testid={`legal-section-${s.heading.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                  <h2>{s.heading}</h2>
                  {s.body.map((p, i) => (
                    <p
                      key={typeof p === "string" ? `${i}-${p.slice(0, 32)}` : `${i}-html`}
                      style={{ marginTop: "var(--s3)" }}
                      dangerouslySetInnerHTML={typeof p === "string" ? undefined : { __html: DOMPurify.sanitize(p.html) }}
                    >
                      {typeof p === "string" ? p : null}
                    </p>
                  ))}
                  {s.bullets ? (
                    <ul style={{ marginTop: "var(--s3)" }}>
                      {s.bullets.map((b, i) => (
                        <li key={typeof b === "string" ? `${i}-${b.slice(0, 32)}` : `${i}-html`}>
                          {typeof b === "string" ? b : <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(b.html) }} />}
                        </li>
                      ))}
                    </ul>
                  ) : null}
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </MarketingShell>
  );
}
